import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Pagination, Stack, Typography } from "@mui/material";
import axiosInstance from "../../../hooks/axiosInstance";
import { toast } from "react-toastify";
import Loader from "../../../components/Utilities/Loader/Loader";
import CreateOrderPaymentAccount from "../../../components/Modal/Admin/Payment/CreateOrderPaymentAccount";
import EditOrderPaymentAccount from "../../../components/Modal/Admin/Payment/EditOrderPaymentAccount";

export default function OrderPaymentAccounts() {
  const [bankAccounts, setBankAccounts] = useState([]);
  const [currentBankAccount, setCurrentBankAccount] = useState(null)
  const [filter, setFilter] = useState("");
  const [show, setShow] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  //  state for pagination
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [pageCount, setPageCount] = useState(1);

  //  pagination function
  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleShow = () => setShow(true)

  const handleShowEdit = async(account) => {
    await setCurrentBankAccount(account)
    setShowEdit(true)
  };

  const handleClose = () => {
    setShow(false);
    setShowEdit(false);
  };
  const handleRefresh = () => {
    setRefreshKey((prevRefreshKey) => prevRefreshKey + 1);
  };

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  const handleDeleteOpen = async (data) => {
    await setCurrentBankAccount(data);
    await setDeleteOpen(true);
  };

  const handleDeleteClose = () => {
    setDeleteOpen(false);
  };

  const fetchUserBankAccounts = () => {
    setLoading(true);
    axiosInstance
      .get(
        `/admin/bank_account?page=${page}&limit=${perPage}&filter=${filter}`
      )
      .then((response) => {
        setBankAccounts(response.data.data.data);
        const pageCount = Math.ceil(
          response.data.data.total / response.data.data.per_page
        );
        setPageCount(pageCount);
      })
      .catch((err) => {
        toast.error("An error occured. Please, try again");
      })
      .finally(() => setLoading(false));
  };

  const handleDelete = () => {
    setLoading(true);
    axiosInstance
      .delete(
        `/admin/bank_account/${currentBankAccount?.id}`
      )
      .then((response) => {
        toast.success("User Bank  account deleted successfully")
        setDeleteOpen(false)
        handleRefresh()
      })
      .catch((err) => {
        toast.error("An error occured. Please, try again");
      })
      .finally(() => setLoading(false));
  };

  const filterBankAccount = () => {
    fetchUserBankAccounts();
  };

  useEffect(() => {
    fetchUserBankAccounts();
  }, [page, perPage, refreshKey]);

  return (
    <>
      <div className="pagetitle">
        <h1>Payment</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <NavLink to="/app/user/dashboard">Dashboard</NavLink>
            </li>
            <li className="breadcrumb-item active">Payment</li>
          </ol>
        </nav>
      </div>

      <section className="section transaction">
        <div className="row">
          <div className="col-lg-12 col-md-12 order-2 order-sm-1 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <div className="d-flex justify-content-between">
                  <div>
                    <h4 className="card-title d-flex align-items-center">
                      Bank Accounts
                    </h4>
                  </div>
                  <div>
                    <button
                      className="vehicle-button mt-3 btn btn-primary btn-sm"
                      onClick={handleShow}
                    >
                      <i className="mdi mdi-plus-circle-outline"></i> New
                      Bank Account
                    </button>
                  </div>
                </div>

                {/* Filter input */}
                {/* <div className="row mb-3">
                  <div className="col-lg-3">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Transaction Reference..."
                        value={filter}
                        onChange={handleFilterChange}
                      />
                      <button
                        onClick={filterBankAccount}
                        className="btn btn-primary"
                        type="submit"
                      >
                        Go
                      </button>
                    </div>
                  </div>
                </div> */}

                {bankAccounts && bankAccounts.length > 0 ? (
                  <>
                    {/* <!-- Start Table --> */}
                    <div className="scroll-area-lg mt-3">
                      <div className="table-responsive-sm">
                        <table className="table table-striped table-borderless table-hover ">
                          <thead>
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Bank Code</th>
                              <th scope="col">Bank Name</th>
                              <th scope="col">Account Name</th>
                              <th scope="col">Account Number</th>
                              <th scope="col">Status</th>
                              <th scope="col" width="5%"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {bankAccounts.map((account, i) => (
                              <tr key={account.id}>
                                <th scope="row">{i + 1}</th>
                                <td>{account?.bank_code}</td>
                                <td>{account?.bank_name}</td>
                                <td>{account?.account_name}</td>
                                <td>{account?.account_number}</td>
                                <td>
                                  <span className={`${account.status == 'active' ? 'bg-success' : 
                                    account.status == 'pending' ?  'bg-warning' : 'bg-danger'
                                   } 
                                    badge text-uppercase`}>
                                    {account?.status}
                                  </span>
                                </td>
                                <td className="dropdown">
                                  <Link
                                    className="dropdown-toggle menu"
                                    id={`actionDropdown_${account.id}`}
                                    href="#"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i className="mdi mdi-apps"></i>
                                  </Link>
                                  <div
                                    className="dropdown-menu dropdown-menu-right preview-list"
                                    aria-labelledby={`actionDropdown_${account.id}`}
                                  >
                                    <Link
                                      className="dropdown-item custom-drop"
                                      onClick={() => handleShowEdit(account)}
                                    >
                                      <i className="mdi mdi-pencil mr-2 text-success"></i>{" "}
                                      <span>Edit</span>
                                    </Link>
                                    <div className="dropdown-divider"></div>
                                    <Link className="dropdown-item custom-drop" onClick={() => handleDeleteOpen(account)}>
                                      <i className="bi bi-trash-fill text-danger"></i>{" "}
                                      <span>Delete</span>
                                    </Link>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end mt-2">
                      <div className="d-flex">
                        per page
                        <select
                          className="ml-1"
                          name="perPage"
                          onChange={(e) => setPerPage(e.target.value)}
                          value={perPage}
                        >
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="15">15</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                        </select>
                      </div>
                      <Pagination
                        onChange={handlePageChange}
                        count={pageCount}
                        color="primary"
                        shape="rounded"
                        size="small"
                        page={page}
                      />
                    </div>
                    {/* <!-- End Table --> */}
                  </>
                ) : (
                  <div className="alert alert-info mt-4">No record found</div>
                )}
              </div>
            </div>
          </div>
        </div>

        <CreateOrderPaymentAccount
          show={show}
          closeModal={handleClose}
          refreshPage={handleRefresh}
        />

        {currentBankAccount && <EditOrderPaymentAccount
          show={showEdit}
          closeModal={handleClose}
          refreshPage={handleRefresh}
          currentBankAccount={currentBankAccount}
        />}

        {/* Delete Dialog */}
        {currentBankAccount && (
          <>
            <Dialog
              open={deleteOpen}
              onClose={handleDeleteClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Delete <b className="text-primary">{currentBankAccount?.account_name}</b> account details
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you want to perform this operation?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button className="text-danger" onClick={handleDeleteClose}>
                  Cancel
                </Button>
                <Button onClick={handleDelete} autoFocus>
                  Continue
                </Button>
              </DialogActions>
              {isDeleteLoading && <Loader />}
            </Dialog>
          </>
        )}

        {loading && <Loader />}
      </section>
    </>
  );
}
